import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { DynamicFieldsContext, DynamicFieldsService } from '../services/dynamic-fields.service';

/**
 * Pinta un formulario definido por configuración (ver DynamicFieldsService).
 * Los valores se escriben directamente sobre el objeto recibido en [data], que es el que el
 * componente padre guarda después.
 *
 * Los tipos ligados a ficheros ('file-upload' y 'files-card') no se pintan aquí: el manejo de
 * adjuntos depende del padre, que los recibe por [extraTemplate] con el campo como contexto.
 */
@Component({
    selector: 'app-dynamic-fields',
    templateUrl: './dynamic-fields.component.html',
    standalone: false
})
export class DynamicFieldsComponent {

  @Input() fields: any[] = [];
  @Input() data: any = {};
  @Input() context: DynamicFieldsContext = {};

  //plantilla del padre para los tipos que no se pintan aquí (file-upload, files-card)
  @Input() extraTemplate: TemplateRef<any> | null = null;

  @Output() fieldChange = new EventEmitter<any>();

  //tipos que delega siempre en el padre
  private parentTypes: string[] = ['file-upload', 'files-card'];

  constructor(public dynamicFieldsService: DynamicFieldsService) { }

  isVisible(field: any): boolean {
    return this.dynamicFieldsService.isVisible(field, this.data);
  }

  isParentType(field: any): boolean {
    return this.parentTypes.includes(field.type);
  }

  getOptions(field: any): any[] {
    return this.dynamicFieldsService.getOptions(field, this.data, this.context);
  }

  //descripción de ayuda de la opción seleccionada, para mostrarla bajo el campo
  getSelectedOptionDescription(field: any): string {
    if (field.type != 'select') return '';
    let value = this.data[field.code];
    if (value == null || value === '') return '';
    let option = this.getOptions(field).find((o: any) => o[field.optionValue ?? 'value'] == value);
    return option?.description ?? '';
  }

  onChange(field: any) {
    this.dynamicFieldsService.applyChange(this.fields, field, this.data, this.context);
    this.fieldChange.emit(field);
  }
}
